import './projectTiles.css';

function GitButton(props){
  if (props.project.gitLink === ""){
    return(
      <div className="noGitContainer">
        <div className='noGit'>
          Please contact me for details on this project and source code
        </div>
      </div>
    );
  } else if ("demo" in props.project){
    return(
      <div className='gitDemo'>
        <a className='gitDemoLeft' href={props.project.gitLink} target="_blank" rel="noopener noreferrer">
          <img className="gitImage" src={"/images/github-mark-white.svg"} alt="git"></img>
        </a>
        <div className='gitDemoRight'>
          Demo Coming Soon
        </div>
      </div>
    )
  }
  return(
    <a className="gitButton" href={props.project.gitLink} target="_blank" rel="noopener noreferrer">
      <img className="gitImage" src={"/images/github-mark-white.svg"} alt="git"></img>
      View on GitHub
    </a>
  );
}

function ProjectTile(props){
  return(
    <div className='tile'>
      <div className='header'>
        <img className='headerImage' src={props.project.image || "/images/ocaml.png"} alt='Tech Image'/>
        <div className='title'>
            {props.project.title || "title"}
        </div>
      </div>
      <div className="descriptionContainer">
        <div className="description">
          {props.project.description}
        </div>
      </div>
      <div className="gitWrapper">
        <GitButton project={props.project}/>
      </div>
    </div>
  );
}

function ProjectTiles(){
  const projects = {ocamlInterpreter: {title: "Ocaml Interpreter", description: "This Ocaml interpreter takes advantage of the algebraic data types and pattern matching abilities of the language to build an interpreter capable of first class functions, conditionals, and having its own stack and memory management system.", image: '/images/ocaml.png', gitLink:"https://github.com/PierceBoyack/Ocaml_Interpreter"},
                    spotifySP: {title: "Intelligent Queueing", description: "A customized Multi-Class Sentiment Classification model and a large-scale Natural Language Processing model. Using these models, a text-based request for a playlist undergoes a semantic analysis and returns a Spotify playlist.", image: "images/spotifySP.png", gitLink: "https://github.com/piercebo/SpotifySP"},
                    aivh: {title: "AI Voice Detection", description: "Several models used to identify retrieval-based AI voices from Human voices.  Models use audio feature extraction and cleaning to acheive up to 97.3% accuracy using 10-fold cross validation.", image: "images/aivh.png", gitLink: "https://github.com/PierceBoyack/AI-vs-Human-Voice-Detection", demo: ""},
                    uwb: {title: "UWB Localizaiton", description: "Ultrawideband is a low-power and precise signal type with multipath resilience, encrpytability, and low latency.  This repo contains a simple Wi-Fi server proxy and ino files for device ranging with ESP-32 boards.", image: "images/esp32.jpg", gitLink: "https://github.com/PierceBoyack/UWB-Localization"},
                    pygame: {title: "Python Royale", description: "A Clash-Royale-like game built using Pygame. It features a built-in enemy AI as well as the option for online multiplayer using peer-to-peer connections. It uses custom characters and specialized sound mixers.", image: "images/pygame.png", gitLink: ""},
                    conways: {title: "Conway's Game of Life", description:"Based on John Horton Conway's cellular automation, the game of life is a turing complete simulation of real life processes. This version was built in C.", image: "images/conways800x800.png", gitLink: ""},
                    malloc: {title: "Dynamic Memory Allocation", description: "Designed a custom dynamic memory allocator in C that replicates the 'malloc', 'realloc', 'calloc', and 'free' operations of the C standard library. Useful for efficient bulk allocation and fragmentation.", image: "images/malloc800x800.png", gitLink: ""},
                    chatPal: {title: "AI IoT", description: "Engineered an AI assistant with Wake Word detection. Used Gemini to personalize the AI, giving it adaptable thinking budgets, and flexible chat memory. Made for both Windows and Raspberry Pi IoT variants.", image: "images/pi.png", gitLink: "https://github.com/PierceBoyack/ChatPal"},
                    pomodoro: {title: "Pomodoro Companion", description: "Made a little fella that manages a pomodoro timer for your study sessions. He hangs out with you as you work.", image: "images/pomo.png", gitLink: "https://github.com/PierceBoyack/Pomodoro"}
                    }
  return (
    <div className='tileContainer'>
      {Object.keys(projects).map((key) => (
        <ProjectTile project={projects[key]}/>
      ))}
    </div>
  )
}

export default ProjectTiles;